<template>
  <div class="logo-on-facade-content" id="identidade-visual-logo-a-logo-em-fachada" data-search-anchor>
    <div class="title-on-facade-wrapper">
      <h1 class="logo-on-facade-title-span">{{ logoOnFacadeTitleSpan }}</h1>
      <h1 class="logo-on-facade-title">{{ logoOnFacadeTitle }}</h1>
    </div>
    <div class="description-on-facade-wrapper">
      <div class="icon-wrapper">
        <IconCheck />
        <p class="logo-on-facade-description">{{ logoOnFacadeDescription }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCancel />
        <p class="logo-on-facade-description">{{ logoOnFacadeDescription1 }}</p>
      </div>
    </div>
    <div class="logo-on-facade-card-item" :style="{ backgroundImage: `url(${logoOnFacadeImageSrc})` }"></div>
  </div>
</template>

<script lang="ts">
import IconCancel from '@/assets/icons/IconCancel.vue'
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck, IconCancel } })
export default class LogoOnFacadeSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoOnFacadeTitleSpan(): string {
    return this.getElementTitle(9, 0)
  }

  get logoOnFacadeTitle(): string {
    return this.getElementText(9, 0)
  }

  get logoOnFacadeDescription(): string {
    return this.getElementText(9, 1)
  }

  get logoOnFacadeDescription1(): string {
    return this.getElementText(9, 2)
  }

  get logoOnFacadeImageSrc(): string {
    return this.getElementMedia(9, 3)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-on-facade-content {
  width: 100%;
  display: grid;
  max-width: 1032px;  
}

.title-on-facade-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.logo-on-facade-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-on-facade-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-on-facade-wrapper {  
  position: relative;  

  display: grid;
  grid-template-columns: 51.2% 48.8%;   
}

.logo-on-facade-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 378px; 
}

.title-image {  
  font-size: 20px;
  font-weight: 600;
  text-align: left;

  padding-left: 3rem;
  width: 187px;
}

.logo-on-facade-card-item {
  position: relative;  
  max-width: 1032px;
  width: 100%;
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain; 
}
</style>
